import React from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { TooltipType } from "utils/enums";
import { T } from "services/lang/LanguageService";

interface TooltipConfigEditorProps<T extends { tooltipType?: TooltipType; tooltip?: string }> {
  config: T;
  onChange: (updated: T) => void;
}

const tooltipOptions = [
  { label: T("label.title-date"), value: TooltipType.TITLE_DATE },
  { label: T("label.custom-text-date"), value: TooltipType.CUSTOM_TEXT_DATE },
  { label: T("word.title"), value: TooltipType.TITLE },
  { label: T("label.custom-text"), value: TooltipType.CUSTOM_TEXT },
  { label: T("word.date"), value: TooltipType.DATE },
];

export default function TooltipConfigEditor<T extends { tooltipType?: TooltipType; tooltip?: string }>({
  config,
  onChange,
}: TooltipConfigEditorProps<T>) {
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement> | DropdownChangeEvent): void => {
    onChange({
      ...config,
      [e.target.id]: e.target.value,
    });
  };

  return (
    <div className="flex flex-row gap-2">
      <div className="flex flex-column w-3 gap-2">
        <label htmlFor="tooltipType">{T("word.tooltip-type")}</label>

        <Dropdown
          id="tooltipType"
          value={config.tooltipType}
          options={tooltipOptions}
          onChange={handleOnChange}
          placeholder={T("word.select-one")}
          className="p-inputtext-sm"
        />
      </div>

      {(config.tooltipType === TooltipType.CUSTOM_TEXT ||
        config.tooltipType === TooltipType.CUSTOM_TEXT_DATE) && (
        <div className="flex flex-column gap-2 w-6">
          <label htmlFor="tooltip">{T("word.tooltip")}</label>

          <InputText
            id="tooltip"
            value={config.tooltip ?? ""}
            onChange={handleOnChange}
            className="p-inputtext-sm"
          />
        </div>
      )}
    </div>
  );
}
